import { render, staticRenderFns } from "./ownership-transfer.vue?vue&type=template&id=1b760516&scoped=true&"
import script from "./ownership-transfer.vue?vue&type=script&lang=ts&"
export * from "./ownership-transfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b760516",
  null
  
)

export default component.exports